<template>
    <div class="account-notifications-conventions">
        <div class="account-notifications-conventions-line">
            <typo name="title-18-bold"> Conventions </typo>
            <v-spacer />
            <typo name="body-14-medium"> Recevoir la veille par email </typo>
        </div>
        <v-row
            v-for="subscription in subscriptions"
            :key="subscription.convention.conventionId"
            class="account-notifications-conventions-line"
        >
            <v-col cols="8">
                <convention-teaser-title :convention="subscription.convention" mode="dashboard" />
                <convention-teaser-info :convention="subscription.convention" mode="dashboard" />
            </v-col>
            <v-spacer />
            <v-col cols="auto">
                <account-notification-convention-action
                    :convention="subscription.convention"
                    :variant="variantByConventionId[subscription.convention.conventionId]"
                />
            </v-col>
            <v-col cols="auto">
                <v-switch
                    :input-value="subscription.isSubscribed"
                    :disabled="isSubmitting"
                    :loading="loading[subscription.convention.conventionId]"
                    @change="
                        updateSubscription(subscription.convention, !subscription.isSubscribed)
                    "
                    hide-details
                    inset
                    class="mt-0"
                />
            </v-col>
        </v-row>
        <v-btn v-if="canShowMore" @click="showAll = !showAll" text large block color="primary">
            {{ showMoreLabel }}
            <v-icon class="ml-5"> mdi-arrow-{{ showAll ? "up" : "down" }} </v-icon>
        </v-btn>
    </div>
</template>

<script>
import ConventionTeaserTitle from "src/components/convention/teaser/ConventionTeaserTitle.vue";
import ConventionTeaserInfo from "src/components/convention/teaser/ConventionTeaserInfo.vue";
import Vue from "vue";
import userMixin from "src/mixins/user";
import { EventBus } from "src/bus/eventBus";
import { isArray, chain, find } from "lodash";
import AccountNotificationConventionAction from "./AccountNotificationConventionAction.vue";

export default Vue.extend({
    mixins: [userMixin],
    props: ["user"],
    components: {
        ConventionTeaserTitle,
        ConventionTeaserInfo,
        AccountNotificationConventionAction,
    },
    data() {
        return {
            isSubmitting: false,
            showAll: false,
            loading: {},
        };
    },
    computed: {
        subscriptions() {
            const subscriptionByConventionId = chain(this.user.selectedConventions || [])
                .keyBy(selectedConvention => selectedConvention.number)
                .mapValues(selectedConvention => selectedConvention.push)
                .value();

            const _subscriptions = (this.user.selectedConventionsPopulated || []).map(
                convention => ({
                    isSubscribed: subscriptionByConventionId[convention.conventionId],
                    convention,
                })
            );
            return this.showAll ? _subscriptions : _subscriptions.slice(0, 2);
        },
        showMoreLabel() {
            return this.showAll ? "Voir moins" : "Voir plus";
        },
        canShowMore() {
            return (
                isArray(this.user.selectedConventionsPopulated) &&
                this.user.selectedConventionsPopulated.length > 2
            );
        },
        variantByConventionId() {
            return chain(this.subscriptions)
                .keyBy(subscription => subscription.convention.conventionId)
                .mapValues(subscription => {
                    const primaryVariant = find(
                        subscription.convention.allVariants,
                        variant => variant.type === "syndiquee" || variant.type === "etendue"
                    );
                    return primaryVariant || subscription.convention.allVariants[0];
                })
                .value();
        },
    },
    methods: {
        async updateSubscription(convention, isSubscribed) {
            try {
                this.loading[convention.conventionId] = true;
                this.isSubmitting = true;
                await this.updateConventionSubscription(convention, isSubscribed);
                EventBus.$emit("alert:success", {
                    message: "Votre modification a bien été prise en compte",
                });
                this.loading[convention.conventionId] = false;
            } catch (e) {
                EventBus.$emit("alert:error", {
                    message:
                        "Une erreur technique est rencontrée. Veuillez contacter le service client Diode.",
                });
            } finally {
                this.isSubmitting = false;
                this.loading = {};
            }
        },
    },
});
</script>

<style lang="sass" scoped>
.account-notifications-conventions-line
    display: flex
    padding: $grid-gutter/2
    align-items: center
</style>
